import AuthGuardDisplay from '@components/AuthGuardDisplay';
import Row from '@components/Row';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

/**
 * 로그아웃, 회원탈퇴
 * @constructor
 */
function AccountFooter() {
    const { t } = useTranslation('accountSetting');
    return (
        <AuthGuardDisplay>
            <Row justify='center' fullWidth>
                <Link activityName='LogoutModal' activityParams={{}}>
                    <AccountButton>
                        {t('buttons.logout')}
                    </AccountButton>
                </Link>
                <Link activityName='AccountTerminationActivity' activityParams={{}}>
                    <AccountButton>
                        {t('buttons.terminate')}
                    </AccountButton>
                </Link>
            </Row>
        </AuthGuardDisplay>
    );
}

const AccountButton = styled.button`
    padding: var(--spacing-4);
    color: var(--color-text-secondary);
    font-size: var(--font-size-body-long);
    background-color: transparent;
`;

export default AccountFooter;
